import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getLanguagesList= async () => {
  const data = await fetchData(ENDPOINTS.GET.LANG_LIST, {
    method: METHODS.GET,
  });
  return data;
};
